import Vue from 'vue'
import Vuex from 'vuex'
import pkg from 'package'
import createPersistedState from 'vuex-persistedstate'
import * as actions from './actions'

import app from './modules/app'
import menu from './modules/menu'
import auth from './modules/auth'

Vue.use(Vuex)

let endpointOptions = [
  { name: 'localhost', baseUrl: 'http://127.0.0.1:8888' },
  { name: 'dev', baseUrl: 'https://dev.triseum.com/api' },
  { name: 'staging', baseUrl: 'https://staging.triseum.com/api' },
  { name: 'live', baseUrl: 'https://portal.triseum.com:8888' },
  { name: 'live-eu', baseUrl: 'https://portal.europe.triseum.com:8888' },
  { name: 'live-ap', baseUrl: 'https://portal.asia.triseum.com/api' },
  { name: 'research', baseUrl: 'https://research.triseum.com/api' }
]

if (process.env.NODE_ENV !== 'development') {
  endpointOptions.shift()
}

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState({ paths: ['auth.sessions', 'endpoint'] })],
  actions,
  getters: {
    device: state => {
      return state.app.device
    },
    effect: state => {
      return state.app.effect
    },
    menuitems: state => {
      return state.menu.items
    },
    notifications: state => {
      return state.app.notifications
    },
    endpointUrl: state => {
      return state.endpointOptions.find((s) => s.name === state.endpoint).baseUrl || 'dev'
    }
  },
  modules: {
    app,
    auth,
    menu
  },
  state: {
    pkg,
    endpoint: process.env.DEFAULT_ENDPOINT || 'dev',
    endpointOptions
  },
  mutations: {
    UPDATE_ENDPOINT (state, newEndpoint) {
      state.endpoint = newEndpoint
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js